import React, {  useEffect, useState } from 'react';
import axios from 'axios';
import { Col, Container, Row } from 'reactstrap';
import { T } from '../../traks';
import { useParams } from 'react-router-dom';
import SibilusNavbar from '../../c/Navbar';
import { AlertModal } from '../../c/Modals';
import LinkCopy from '../../c/LinkCopy';
import { RenderIf } from '../../helpers/RenderIf';
import { StepOne } from './StepOne';
import { IntroStep } from './IntroStep';
import { StepTwo } from './StepTwo';
import { Loading } from '../../c/Loading';
import { APIPost, APIGet } from '../../API';

const LinkHeader = () => {
	return (<>
		<div className="pt-2 pt-lg-5 font_20px">
			<T>Save this link somewhere safe.</T>
		</div>
		<div className="pb-3 pb-lg-5 font_14px">
			<i><T>If you loose it, you have no way to get back to your case.</T></i>
		</div>
	</>);
}

const CreateWhistlePage = () => {
	const { link_id } = useParams();
	const [showAlert, setShowAlert] = useState(false)
	const [showLoading, setShowLoading] = useState(false)
	const [showIntro, setShowIntro] = useState(true);
	const [activeStep, setActiveStep] = useState(1)
	const [recipients, setRecipients] = useState([])
	const [company, setCompany] = useState(undefined)
	const [alertType, setAlertType] = useState({ type: "", text: "" })
	const [createdWhistle, setCreatedWhistle] = useState({ access_id: "" });
	const [whistle, setWhistle] = useState({
		content: '',
		link: link_id,
		recipient_id: null,
		name: null,
		email: null,
		phone_number: null,
		screen_name: null,
		meeting_details: null,
		type: null,
		mode: null,
		agreeToTerms: false
	});

	const uploadFiles = (files, whistleId, preSignedUrls, access_id) => {
		const promises = preSignedUrls.forEach((url, index) => {
			const file = files[index]
			const fileContent = file.file
			const headers = {
				"Content-Type": file.type,
			}
			headers["x-amz-meta-accessid"] = access_id
			headers["x-amz-meta-screenname"] = "whistle_owner"
			headers["x-amz-meta-filename"] = file.name
			axios.put(url, fileContent, { headers }).then(res => {
				const logBody = {
					whistle_id: whistleId,
					agent: "whistle_owner",
					log_action: "uploaded_files",
					action: "create_log",
					notify: false,
					file_name: file.name,
					access_id: access_id
				}
				APIPost(`whistles/${whistleId}/log`, logBody).then(res =>
					console.log(res)
				).catch(err =>
					console.log(err)
				)
			}).catch(err => console.log(err))
		})

		Promise.all(promises).then(res => console.log(res)).catch(err => console.log(err))
	}

	const submitWhistle = (whistle, files) => {
		setShowLoading(true)
		const filesInfo = files.map(({ file, src, ...f }) => f)
		const body = { ...whistle, files: filesInfo }
		APIPost('whistles', body).then((res) => {
			const { access_id, upload_files, whistle_id } = res.data;
			setCreatedWhistle({ access_id: access_id });
			if (files.length > 0 && upload_files && upload_files.presigned_urls.length) {
				uploadFiles(files, whistle_id, upload_files.presigned_urls, access_id)
			}
			setShowLoading(false)
			setAlertType({ text: "Your case has been successfully submitted!", type: "success" })
			setShowAlert(true)
		}).catch((error) => {
			setShowLoading(false)
			setAlertType({ text: "An error has happened", type: "error" })
			setShowAlert(true)
		});
	};

	const nextStep = () => {
		setActiveStep(activeStep + 1)
	}

	const previousStep = () => {
		setActiveStep(activeStep - 1)
	}

	const buttonDisabled = () => {
		const writtenWhistle = whistle.content && whistle.recipient_id;
		return !writtenWhistle
	}

	useEffect(() => {
		setShowLoading(true);
		APIGet("whistlelinks/" + link_id).then(res => {
			setShowLoading(false);
			setCompany(res.data.company)
			setRecipients(res.data.recipients);
		}).catch(err => {
			setShowLoading(false);
			console.log(err);
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps	
	}, []);

	return recipients && (
		<>
			<RenderIf condition={whistle.mode === "nonanonymous"}>
				<SibilusNavbar nonanonymous />
			</RenderIf>
			<RenderIf condition={whistle.mode !== "nonanonymous"}>
				<SibilusNavbar anonymous />
			</RenderIf>
			<RenderIf condition={!createdWhistle.access_id}>
				<RenderIf condition={showIntro && company}>
					<IntroStep
						whistle={whistle}
						setWhistle={setWhistle}
						nextStep={setShowIntro}
						company={company}
					/>
				</RenderIf>
				<RenderIf condition={activeStep === 1 && !showIntro}>
					<StepOne
						whistle={whistle}
						setWhistle={setWhistle}
						nextStep={nextStep}
					/>
				</RenderIf>
				<RenderIf condition={activeStep === 2}>
					<StepTwo
						submitBtnDisabled={buttonDisabled()}
						previousStep={previousStep}
						whistle={whistle}
						setWhistle={setWhistle}
						recipients={recipients}
						submitWhistle={submitWhistle}
					/>
				</RenderIf>
			</RenderIf>
			<RenderIf condition={createdWhistle.access_id}>
				<Container fluid>
					<Row>
						<Col xs={12} >
							<LinkHeader />
							<LinkCopy
								link={"whistle"}
								pathId={createdWhistle.access_id}
							/>
						</Col>
					</Row>
				</Container>
			</RenderIf>
			<Loading
				showLoading={showLoading}
				inFront
				overlay
			/>
			<AlertModal
				isShowing={showAlert}
				setIsShowing={setShowAlert}
				type={alertType.type}
				text={alertType.text}
			/>
		</>
	);
};

export default CreateWhistlePage
